module.exports = __webpack_public_path__ + "static/media/chart.e8da446f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chart.svg
// module id = 365
// module chunks = 0